import { c as _c } from "react/compiler-runtime";
import { Fragment, type ReactNode } from 'react';
import type { InlineMarkupRegistry } from '../inline-markup-registry';
export type InlineTextProps = {
  text: string;
  editable?: boolean;
  registry: InlineMarkupRegistry;
};
const InlineText = t0 => {
  const $ = _c(7);
  const {
    text,
    editable: t1,
    registry
  } = t0;
  const editable = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== editable || $[1] !== registry || $[2] !== text) {
    const parts = [];
    let lastIndex = 0;
    for (const {
      index,
      raw,
      token,
      entry
    } of registry.parseTokens(text)) {
      if (index > lastIndex) {
        parts.push(text.slice(lastIndex, index));
      }
      parts.push(<Fragment key={`${token.kind}:${index}`}>{entry.renderReact(token as never, {
          editable,
          raw
        })}</Fragment>);
      lastIndex = index + raw.length;
    }
    if (lastIndex < text.length) {
      let t3;
      if ($[4] !== lastIndex || $[5] !== text) {
        t3 = text.slice(lastIndex);
        $[4] = lastIndex;
        $[5] = text;
        $[6] = t3;
      } else {
        t3 = $[6];
      }
      parts.push(t3);
    }
    t2 = <>{parts}</>;
    $[0] = editable;
    $[1] = registry;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default InlineText;